const verify = {
  "verify.title": "Verify OTP",
  "verify.subtitle": "Enter the code sent to",
  "verify.codeLabel": "OTP Code",
  "verify.codePlaceholder": "123456",
  "verify.submit": "Verify & Sign In",
  "verify.verifying": "Verifying...",
  "verify.error.invalidOtp": "Please enter a valid OTP code",
  "verify.error.expired": "Session expired. Please go back and enter your phone number again.",
  "verify.error.wrongOtp": "Invalid OTP",
  "verify.expired.title": "Session Expired",
  "verify.expired.message": "Please go back and enter your phone number again.",
  "verify.expired.backToLogin": "Back to Login",
  "verify.wrongNumber": "Wrong number?",
  "verify.goBack": "Go back",
};

export default verify;